module.exports = __webpack_public_path__ + "img/icon-warning.80eca2e1.svg";